import { jsxs as _jsxs } from "react/jsx-runtime";
import cx from "classnames";
import { memo } from "react";
export const MegaMenuTitle = memo(({ endAdornment, title, className }) => {
    if (title) {
        return (_jsxs("span", { className: cx(className, {
                "flex items-start gap-1 text-current": Boolean(endAdornment),
            }), children: [title, endAdornment && endAdornment] }));
    }
    return null;
});
//# sourceMappingURL=MegaMenuTitle.js.map